export function getQueryName(
	operationName: string | null | undefined,
	variables: any,
	sanitize: boolean = false,
) {
	if (!operationName) return '';

	let name = operationName;
	if (operationName === 'WebItemLocationQuery' || operationName === 'WebPanelLocationQuery') {
		name = `${operationName}:${
			variables?.location || (variables?.locations || []).join(',') || ''
		}`;
	} else if (operationName === 'FetchPreFilteredForgeAppsQuery') {
		name = `${operationName}:${variables?.types?.join(',') || ''}`;
	} else if (operationName === 'onboardingStateGetOnboardingStateQuery') {
		const keys = Array.isArray(variables?.key) ? variables.key : [];
		if (keys.length === 1) {
			name = `${operationName}:${keys[0] || ''}`;
		} else if (keys.length > 1) {
			const firstKey = keys[0] || '';
			name = `${operationName}:${firstKey}_${keys.length}`;
		}
	}
	if (sanitize) {
		return name.replace(/[^\-\.\w]/g, '_');
	}
	return name;
}
